/**
 * @typedef {import('mdast').HTML} HTML
 * @typedef {import('../index.js').Handler} Handler
 */
import { u } from 'unist-builder';
/**
 * Return either a `raw` node in dangerous mode, otherwise nothing.
 *
 * @type {Handler}
 * @param {HTML} node
 */

export function html(h, node) {
  return h.dangerous ? h.augment(node, u('raw', node.value)) : null;
}